var _excluded = ["children", "message", "onChange", "onReject", "multiple", "maxSize", "className", "id"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useRef, useState } from 'react';
import { forwardRef, tqc, useMultiStyleConfig } from '../../../system';
import { cx, mergeRefs, dataAttr, split } from '../../../utils';
import { useId } from '../../../hooks';
import { useFormControl, Flex, Text, VisuallyHiddenInput } from '../../../components';
var noop = () => {};
export var FilePicker = forwardRef((props, ref) => {
  var {
      children = 'Choose file',
      message = 'No file chosen',
      onChange = noop,
      onReject = noop,
      multiple = false,
      maxSize = Infinity,
      className,
      id
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  var [files, setFiles] = useState([]);
  var styles = useMultiStyleConfig('FilePicker', rest);
  var inputRef = useRef(null);
  var labelRef = useRef(null);
  var generatedId = useId(id, '');
  var [iProps, containerProps] = split(rest, ['id', 'name', 'isInvalid', 'required', 'disabled']);
  var inputProps = useFormControl(_objectSpread(_objectSpread({}, iProps), {}, {
    id: generatedId
  }));
  var handleKeyDown = event => {
    if (inputRef.current === null) return;
    if (event.key === 'Enter') {
      inputRef.current.click();
    }
  };
  var handleChange = event => {
    var _labelRef$current;
    if (!event.target.files) return;
    var files = Array.from(event.target.files);
    var isValid = files.reduce((isValid, file) => {
      return isValid && file.size <= maxSize;
    }, true);
    if (isValid) {
      setFiles(files);
      onChange(files, event);
    } else {
      event.target.value = '';
      setFiles([]);
      onReject(files, event);
    }
    (_labelRef$current = labelRef.current) === null || _labelRef$current === void 0 ? void 0 : _labelRef$current.focus();
  };
  return /*#__PURE__*/React.createElement(Flex, _extends({
    alignItems: "center",
    className: cx('tqc-file-input', className),
    sx: _objectSpread({
      display: 'inline-flex'
    }, styles.container)
  }, containerProps), /*#__PURE__*/React.createElement(tqc.label, {
    ref: labelRef,
    tabIndex: 0,
    role: "button",
    htmlFor: inputProps.id,
    onKeyDown: handleKeyDown,
    "data-invalid": dataAttr(inputProps['aria-invalid']),
    "data-required": dataAttr(inputProps['aria-required']),
    "data-disabled": dataAttr(inputProps.disabled),
    className: "tqc-file-input__button",
    __css: styles.button
  }, children), /*#__PURE__*/React.createElement(VisuallyHiddenInput, _extends({
    type: "file",
    className: "tqc-file-input__element",
    ref: mergeRefs(inputRef, ref),
    tabIndex: -1,
    onChange: handleChange,
    multiple: multiple
  }, inputProps)), /*#__PURE__*/React.createElement(Text, {
    "aria-live": "polite",
    sx: styles.text,
    className: "tqc-file-input__message"
  }, files.length > 0 ? files.map(f => f.name).join(', ') : message));
});